import React, { useEffect, useState } from "react";
import { Button, Card, Loader, Row, Slider } from "@kaleyra/emmy";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import Styles from "./index.module.scss";
import voiceIcon from "../../../../assets/voice.svg";

export type MapStateType = {
    voiceTemplatesInProgress: boolean;
    voiceTemplateList: any[];
}

export type DispatchPropsType = {
    onClose: () => void;
    updateTemplateIdInStore: (id: string) => void;
}

const VoiceTemplates: React.FC<MapStateType & DispatchPropsType> = ({ onClose, voiceTemplatesInProgress, voiceTemplateList, updateTemplateIdInStore }) => {

    const [selectedTemplateId, setSelectedTemplateId] = useState("");
    const { t } = useTranslation();

    const renderWAList = () => {
        if (voiceTemplatesInProgress) {
            return <Loader />
        }
        if (!voiceTemplatesInProgress && voiceTemplateList.length === 0) {
            return <p>{t('mainNoTemplates')}</p>;
        }
        return (<>
            {voiceTemplateList.map((voiceTemplateItem: any, index: number) => <>
                <Card className={cn(Styles.card, selectedTemplateId === voiceTemplateItem.id ? Styles.selectedCard : "")}
                    showHoverBorder={false}
                    key={index}
                    onClick={() => setSelectedTemplateId(voiceTemplateItem.id)}>
                    <div className={Styles.header}>
                        <img src={voiceIcon} alt="voice-icon" />
                        <div className={Styles.title}>
                            <span className={Styles.headTitle}>{voiceTemplateItem.name}</span>
                            <p className={Styles.description}>
                                <span>{voiceTemplateItem.created_at}</span>
                                <span>&#8226;</span>
                                <span>{voiceTemplateItem.created_by}</span>
                            </p>
                            <p className={Styles.description}>{voiceTemplateItem.body}</p>
                        </div>
                    </div>
                </Card>
            </>)}
        </>);
    }

    const handleSaveTemplate = () => {
        updateTemplateIdInStore(selectedTemplateId);
        onClose();
    }

    const renderSliderFooter = () => {
        return (
            <Row className={cn(Styles.footerRow, Styles.footerPosition)}>
                <Button type="tertiary" onClick={onClose}>{t('mainCancel')}</Button>
                <Button disabled={selectedTemplateId === ""} onClick={() => handleSaveTemplate()}>{t('mainSave')}</Button>
            </Row>)
    }

    return (
        <Slider
            containerId="root-modal"
            onClose={onClose}
            visibility={true}
            footer={renderSliderFooter()}
            title={'Select Voice template'}
        >{renderWAList()}</Slider>
    )
}

export default VoiceTemplates;